import { MarcacaoExamePorIdResolver } from './marcacao-exame-por-id.resolver';
import { CfcPorCnpjResolver } from './cfc-por-cnpj.resolver';
import { CfcResolver } from './cfc.resolver';
import { FotobiometriaPorIdResolver } from './fotobiometria-por-id.resolver';
import { InstrutorCfcResolver } from './instrutor-cfc.resolver';
import { InstrutorPorCpfResolver } from './instrutor-por-cpf.resolver';
import { InstrutorResolver } from './instrutor.resolver';
import { LocalPorIdResolver } from './local-por-id.resolver';
import { LocalResolver } from './local.resolver';
import { MarcacaoExameDisponibilidadePorIdResolver } from './marcacao-exame-disponibilidade-por-id.resolver';
import { MarcacaoExameDisponibilidadeBloqueioPorIdResolver } from './marcacao-exame-disponibilidade-bloqueio-por-id.resolver';
import { MatriculaGestaoPorIdResolver } from './matricula-gestao-por-id.resolver';
import { ServicosGestaoResolver } from './servicos-gestao.resolver';
import { UnidadeDetranResolver } from './unidade-detran.resolver';
import { VeiculoCfcResolver } from './veiculo-cfc.resolver';
import { VeiculoResolver } from './veiculo.resolver';
import { MatriculaEventoResolver } from './matricula-evento.resolver';
import { CreditoResolver } from './credito.resolver';
import { DelegaciaPorIdResolver } from './delegacia-por-id.resolver';
import { DelegaciaResolver } from './delegacia.resolver';
import { DocumentoPorIdResolver } from './documento-por-id.resolver';
import { FeriadoPorIdResolver } from './feriado-por-id.resolver';
import { TipoExameResolver } from './tipo-exame.resolver';
import { GrupoCfcPorIdResolver } from './grupo-cfc-por-id.resolver';
import { GrupoPorIdResolver } from './grupo-por-id.resolver';
import { GrupoResolver } from './grupo.resolver';
import { NotificacaoPorIdResolver } from './notificacao-por-id.resolver';
import { RegiaoPorIdResolver } from './regiao-por-id.resolver';
import { RegiaoResolver } from './regiao.resolver';
import { SituacaoFinanceiraAssociadoPorIdResolver } from './situacao-financeira-associado-por-id.resolver';
import { UnidadeDetranResolverPorId } from './unidade-detran-por-id.resolver';
import { FotobiometriaDisponibilidadePorIdResolver } from './fotobiometria-disponibilidade-por-id.resolver';
import { LocalFotobiometriaPorIdResolver } from './local-fotobiometria-por-id.resolver';
import { ProvedorResolver } from './provedor.resolver';
import { DocumentoResolver } from './documento.resolver';
import { TipoDocumentoResolver } from './tipo-documento.resolver';
import { FotobiometriaDisponibilidadeBloqueioPorIdResolver } from './fotobiometria-disponibilidade-bloqueio-por-id.resolver';
import { LocalAtendimentoDetranResolver } from './local-atendimento-detran.resolver';

export const GestaoResolvers = [
  CfcPorCnpjResolver,
  CfcResolver,
  CreditoResolver,
  DelegaciaPorIdResolver,
  DelegaciaResolver,
  DocumentoResolver,
  DocumentoPorIdResolver,
  FeriadoPorIdResolver,
  FotobiometriaPorIdResolver,
  FotobiometriaDisponibilidadePorIdResolver,
  FotobiometriaDisponibilidadeBloqueioPorIdResolver,
  GrupoCfcPorIdResolver,
  GrupoPorIdResolver,
  GrupoResolver,
  InstrutorCfcResolver,
  InstrutorPorCpfResolver,
  InstrutorResolver,
  LocalFotobiometriaPorIdResolver,
  LocalPorIdResolver,
  LocalResolver,
  LocalAtendimentoDetranResolver,
  MarcacaoExameDisponibilidadeBloqueioPorIdResolver,
  MarcacaoExameDisponibilidadePorIdResolver,
  MarcacaoExamePorIdResolver,
  MatriculaEventoResolver,
  MatriculaGestaoPorIdResolver,
  NotificacaoPorIdResolver,
  ProvedorResolver,
  RegiaoPorIdResolver,
  RegiaoResolver,
  ServicosGestaoResolver,
  SituacaoFinanceiraAssociadoPorIdResolver,
  TipoExameResolver,
  TipoDocumentoResolver,
  UnidadeDetranResolver,
  VeiculoResolver,
  VeiculoCfcResolver,
  UnidadeDetranResolverPorId
]
